import { render, staticRenderFns } from "./RedirectView.vue?vue&type=template&id=4887ddf4&scoped=true&"
import script from "./RedirectView.vue?vue&type=script&lang=ts&"
export * from "./RedirectView.vue?vue&type=script&lang=ts&"
import style0 from "./RedirectView.vue?vue&type=style&index=0&id=4887ddf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4887ddf4",
  null
  
)

export default component.exports